module.exports = __webpack_public_path__ + "static/img/win-4.11197bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/win/win-4.png
// module id = 258
// module chunks = 6